const generalInfo = {
  // General Info - Company Information
  applicantType: '',
  companyName: '',
  yearEst: undefined,
  stateInc: '',
  yearsWithName: undefined,
  priorCompanyNames: '',
  hqMailingAddress: '',
  hqStreetAddress: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  // General Info - POC Name/Title
  pocFirstName: '',
  pocLastName: '',
  pocTitle: '',
  pocEmail: '',
  pocPhoneNumber: '',
  pocAltEmail: '',
  // General Info - Alutiiq Contact
  revenue: '',
  alutiiqContactFirstName: '',
  alutiiqContactLastName: '',
  division: '',
  alutiiqSubsidiary: '',
  // General Info - Additional Information
  DCAAPOCFirstName: '',
  DCAAPOCLastName: '',
  DCAAPOCPhone: '',
  DCAAPOCEmail: '',
};

const businessProfile = {
  // Business Profile - Business Profile
  businessClass: '',
  owners: [
    { name: '', title: '', ownership: '' },
  ],
  isOwnerOtherCompanies: '',
  isOwnerFamily: '',
  // Business Profile - Socio Economic Status
  socioEconomicStatus: [],
  rblCerts: '',
  rblRegisteredDunBradstreet: '',
  ueiNumber: '',
  dbNumber: '',
  dbYear: '',
  taxID: '',
  companyWebsite: '',
  SAMRegistration: '',
  CAGECode: '',
  NAICSCode: '',
  otherNAICSCodes: '',
  businessProfileAreYouManufacturer: '',
  businessProfileMajorProductsManufactured: '',
  businessProfileDoEngageConsulting: '',
  businessProfileMajorAreasExpertise: '',
  businessProfileDoSubcontractLabor: '',
  businessProfilePrimaryService: '',
  businessProfileStatesConductBusiness: '',
  businessProfileGrossIncome: '',
  ffataForm: '',
  businessProfileCompensationInformationAccess: '',
  businessProfileEightyPercentRevenue: '',
  businessProfileTwentyFiveMillionRevenue: '',
};

const capabilities = {
  // Capabilities - Capabilities
  businessActivities: [],
  txtkStates: '',
};

const pastPerformance = {
  // Past Performance - Past Performance
  capableCertifiedPayrolls: '',
  receivedShowOfCauseEtc: '',
  receivedShowOfCauseEtcExplanation: '',
  receivedNoticeOfDefault: '',
  receivedNoticeOfDefaultExplanation: '',
  everBankrupt: '',
  everBankruptExplanation: '',
  everDisbarred: '',
  everDisbarredExplanation: '',
  everFined: '',
  everFinedExplanation: '',
  issuesWithDCAA: '',
  issuesWithDCAAExplanation: '',
};

const bonding = {
  // Bonding - Bonding Program Information
  suretyBondingProgram: '',
  bidBonds: '',
};

const insuranceAndSafety = {
  // Insurance and Saftey - Insurance Information
  insuranceRequiredByScopeofWork: '',
  // Insurance and Saftey - Safety
  safetyPro: '',
  pName: '',
  pTitle: '',
  pPhone: '',
  pEmail: '',
  OSHACitations: '',
  oshaCitationType: '',
  oshaFineAmounts: '',
  oshaAbatement: '',
  oshaContact: '',
};

const securityAndCertifications = {
  // Security and Certifications - Status of Subcontractor Business Systems
  accountingSystem: '',
  accountingSystemApprovalDate: '',
  purchasingSystem: '',
  estimatingSystem: '',
  propertySystem: '',
  compliantIT: '',
  compliantITFileName: '',
  canReviewSSP: '',
  // Security and Certifications - Security Clearance
  facilitySecurityClearance: '',
  securityClearances: [
    { federalAgency: '', clearanceLevel: '', dateOfApproval: '' }
  ],
  cageCodes: [
    { SSP: '', supportedBySSP: '', dateOfAssessment: '', totalScore: '', estimatedDateOfAchievement: '' }
  ],
  securityClearanceNotes: '',
  NISTSP800171Compliant: '',
  SecuritySystemPlan: '',
  securitySystemPlanFileName: '',
  NISTSP800171Assessment: '',
  NISTSP800171AssessmentFileName: '',
  NISTSP800171AssessmentScore: '',
  NISTSP800171AssessmentDate: '',
  NISTSP800171AssessmentDateofScore110: '',
  CybersecurityMaturityModelCertified: '',
  CybersecurityMaturityModelCertifiedDate: '',
  CybersecurityMaturityModelCertifiedCMMCLevel: '',
  CybersecurityMaturityModelCertifiedCMMCPassingScore: '',
  poamSSP: '',
  companyAssessmentScore: ''

};

const compliance = {
  // Compliance - Combatting Trafficking in Persons
  awareOfFARClause: '',
  haveEndingTraffickingPolicy: '',
  freeToTerminate: '',
  freeToTerminateExplanation: '',
  depositsRequired: '',
  depositsRequiredExplanation: '',
  assessPossibleTrafficking: '',
  assessPossibleTraffickingExplanation: '',
  freqAssessPossibleTrafficking: '',
  possibleTrafficking: '',
  possibleTraffickingExplanation: '',
  otherEndingTraffickingPolicy: '',
  boycottTraffickers: '',
  haveCodeOfBusinessEthicsAndConduct:'',
  codeOfBusinessEthicsAndConduct:'',
  haveCodeTrainingMaterials:'',
  codeTrainingMaterials:''
}

const signature = {
  // Signature - Required Materials and File Uploads
  w9: '',
  coi: '',
  balanceSheet: '',
  workersCompensationEMR: '',
  endingTraffickingPolicy: '',
  codeTrainingMaterials:'',
  codeOfBusinessEthicsAndConduct:'',
  // Signature - Ending Trafficking in Persons Compliance Statement / Authorization to Release Information
  signatureFirstName: '',
  signatureLastName: '',
  signatureTitle: '',
  signatureDate: '',

  submitted: ''
};

const initialValues = {
  ...generalInfo,
  ...businessProfile,
  ...capabilities,
  ...pastPerformance,
  ...bonding,
  ...insuranceAndSafety,
  ...securityAndCertifications,
  ...compliance,
  ...signature,
};

const stepToFields = {
  'General Info': Object.keys(generalInfo),
  'Business Profile': Object.keys(businessProfile),
  'Capabilities': Object.keys(capabilities),
  'Past Performance': Object.keys(pastPerformance),
  'Bonding': Object.keys(bonding),
  'Insurance and Safety': Object.keys(insuranceAndSafety),
  'Security and Certifications': Object.keys(securityAndCertifications),
  'Compliance': Object.keys(compliance),
  'Signature': Object.keys(signature),
} as { [key: string]: string[] };

const fieldToStep = Object.keys(stepToFields).reduce((fieldToStep, step) => {
  stepToFields[step].forEach(field => {
    fieldToStep[field] = step;
  })
  return fieldToStep;
}, {} as { [key: string]: any });

export default initialValues;

export { fieldToStep, stepToFields };
